import { URLServiceComponent } from './URLServiceComponent';
export const OAuthReconnectionConfig = {
  serviceComponent: URLServiceComponent
};